import { render, staticRenderFns } from "./ShareSolid.vue?vue&type=template&id=3cd12d57&"
import script from "./ShareSolid.vue?vue&type=script&lang=ts&"
export * from "./ShareSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports